import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'

import { PreOrderFetchAPI } from '../../../api/Paymentpost/PreOrder';
import { DeletedTempOrdersFetchAPI } from '../../../api/DeletedTemporalOrders';

import Swal from "sweetalert2";

import imgPreOrder from '../../PaymentPost/img/logo_sp.png'
import refund from '../../PaymentPost/img/logo_sp.png'

import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import { GiPlayerTime } from 'react-icons/gi';
import Empty from '../../utils/Empty';
import ModalDetailPreOrder from '../ModalDetailPreOrder';
import ModalDivisionByProduct from './ModalDivisionByProduct';


import { splitCombosByUnit, splitGroupsByUnit } from '../../../utils/PreOrderSplit';
import './styles.css'

function ModalDivisionByProductPart({ getOrderNumber, orderNumberNow, order, setShowDivision, getAll, onPendingDelete, codeParthner, resetInputs }) {
    const [showPartsByProducts, setShowPartsByProducts] = useState(false);
    const [showByProduct, setShowByProduct] = useState(false);
    const [dataOrder, setDataOrder] = useState({});
    const [division, setDivision] = useState(0);
    const [parts, setParts] = useState([])

    const newPartsOrder = () => {
        let arrayParts = [];
        let groupsByUnit = splitGroupsByUnit(order.groups);
        let combosByUnit = splitCombosByUnit(order.combos);

        order.groups = groupsByUnit
        order.combos = combosByUnit

        let arrayProducts = groupsByUnit.concat(combosByUnit)
        let partsByUnit = 0;
        arrayProducts.forEach(item => {
            partsByUnit = partsByUnit + item.amount;
        })

        for (let index = 0; index < partsByUnit; index++) {
            arrayParts.push((index + 1));
        }
        setParts(arrayParts);
        console.log(arrayParts);
    }

    const actionDivisionParts = () => {
        if ((order.groups.length + order.combos.length) > 1) {
            setShowPartsByProducts(true)
        } else {
            ErrorAlert("", "Esta precuenta solo tiene un producto", "warning")
        }

    }

    useEffect(() => {
        newPartsOrder();
    }, [])


    return (
        <>
            {/* Botón disparador */}
            <button type="button" className="sp-divopt" onClick={() => actionDivisionParts()}>
                <span className="sp-divopt__ic"><i className="uil uil-minus-path"></i></span>
                <span className="sp-divopt__label">Por productos</span>
            </button>

            <Modal
                show={showPartsByProducts}
                fullscreen
                 centered
                onHide={() => setShowPartsByProducts(false)}
                aria-labelledby="example-custom-modal-styling-title"
                // contentClassName="sp-divm-content"
            >
                <Modal.Body className="sp-divm">

                    <div className="sp-divm__head">
                        {/* <div className="sp-divm__badge"><i className="uil uil-apps"></i></div> */}
                        <h4 className="sp-divm__title">Dividir en partes iguales</h4>
                        <button className="sp-divm__x" type="button" aria-label="Cerrar" onClick={() => setShowPartsByProducts(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <div className="sp-divm__body">
                        <div className="sp-divm__detail">
                            <ModalDetailPreOrder orderData={order}></ModalDetailPreOrder>
                        </div>

                        <div className="sp-divm__sectlabel"><i className="uil uil-ellipsis-v"></i> Selecciona en cuántas cuentas separar los productos</div>

                        <div className="sp-divm__parts">
                            {parts.map((index) => (
                                index > 1 ? (
                                    <button type="button" className="sp-divm__part" key={index} onClick={() => (setDivision(index), setShowByProduct(true))}>
                                        <i className="uil uil-minus-path"></i>
                                        <span>{index}</span>
                                    </button>
                                ) : null
                            ))}
                        </div>
                    </div>

                    <div className="sp-divm__foot">
                        <button className="sp-divm__btn sp-divm__btn--cancel" onClick={() => setShowPartsByProducts(false)}>Cancelar</button>
                    </div>

                </Modal.Body>
            </Modal>

            <ModalDivisionByProduct getOrderNumber={getOrderNumber} orderNumberNow={orderNumberNow} order={order} setShowDivision={setShowDivision} getAll={getAll} onPendingDelete={onPendingDelete} setShowPartsByProducts={setShowPartsByProducts} showByProduct={showByProduct} setShowByProduct={setShowByProduct} division={division} codeParthner={codeParthner} resetInputs={resetInputs}></ModalDivisionByProduct>        </>

    )
}

export default ModalDivisionByProductPart
